import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function Layout({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  const isActive = (path) => location.pathname === path || location.pathname.startsWith(path + '/');

  return (
    <div className="min-h-screen flex flex-col bg-slate-50">
      <header className="bg-white border-b border-slate-200 sticky top-0 z-40">
        <div className="max-w-6xl mx-auto px-4 h-16 flex items-center justify-between">
          <Link to="/dashboard" className="flex items-center gap-2 font-extrabold text-lg">
            <span className="w-8 h-8 rounded-lg bg-brand-500 text-white grid place-items-center">GF</span>
            <span>Go Fiesta</span>
          </Link>

          <nav className="hidden md:flex items-center gap-1">
            <Link to="/dashboard" className={`px-4 py-2 rounded-lg text-sm font-semibold ${isActive('/dashboard') ? 'bg-brand-50 text-brand-600' : 'text-slate-600 hover:bg-slate-100'}`}>
              Mis eventos
            </Link>
            <Link to="/templates" className={`px-4 py-2 rounded-lg text-sm font-semibold ${isActive('/templates') ? 'bg-brand-50 text-brand-600' : 'text-slate-600 hover:bg-slate-100'}`}>
              Plantillas
            </Link>
          </nav>

          <div className="flex items-center gap-3">
            <span className="hidden sm:block text-sm text-slate-500">{user?.email}</span>
            <button
              onClick={handleLogout}
              className="text-sm font-semibold text-slate-600 hover:text-red-600"
            >
              Salir
            </button>
          </div>
        </div>
      </header>

      <main className="flex-1 max-w-6xl w-full mx-auto px-4 py-8">{children}</main>

      <footer className="text-center text-xs text-slate-400 py-6">
        © {new Date().getFullYear()} Go Fiesta
      </footer>
    </div>
  );
}